import React, { useState } from 'react';
import { getHexColorString, getOpacityFromRgba, getRgba } from '../../../../helpers/helpers';
import FieldWrapper from './FieldWrapper';
import FileAttachmentModal from '../../Editors/FileAttachmentModal';
import Label from '../../../../components/svg/Label';
import { analyticsTrack } from '../../../../helpers/AnalyticsUtility';
import { ValueChangedForFieldFunc } from '../../../formeditor-types';

export interface FileAttachmentFieldProps {
  valueUpdated: ValueChangedForFieldFunc;
  id?: string;
  fieldId?: string;
  x?: number;
  y?: number;
  w?: number;
  h?: number;
  align?: string;
  foregroundColor?: TypeMePlease;
  backgroundColor?: TypeMePlease;
  displayType?: number;
  maxSize?: number;
  padding?: number;
  editable: boolean;
  value?: string;
  maxFileSize?: number;
  maxFileCount?: number;
  allowedFileTypes?: string;
  name?: string;
  fontName?: string;
  fontSize?: number;
  fieldType?: TypeMePlease;
  focusColor?: TypeMePlease;
  view?: string;
  templateId?: string;
  templateName?: string;
  formId?: string;
  formName?: string;
  tabIndex?: number;
}

export default function FileAttachmentField(props: FileAttachmentFieldProps) {
  const [modalOpen, setModalOpen] = useState(false);

  const parsedValue = props.value ? JSON.parse(props.value) : null;

  const mouseDown = () => {
    setModalOpen(true);
    analyticsTrack('File Attachment Field Opened', {
      view: props.view == 'list' ? 'List View' : 'Form View',
      templateId: props.templateId,
      templateName: props.templateName,
      formId: props.formId,
      formName: props.formName,
      fieldId: props.fieldId,
      fieldName: props.name
    });
  };

  let fileAttachmentModal = null;
  if (modalOpen) {
    fileAttachmentModal = (
      <FileAttachmentModal
        name={props.name}
        onClose={() => setModalOpen(false)}
        maxFileSize={props.maxFileSize}
        maxFileCount={props.maxFileCount}
        allowedFileTypes={props.allowedFileTypes}
        value={props.value}
        valueUpdated={props.valueUpdated}
        editable={props.editable}
        view={props.view}
        templateId={props.templateId}
        templateName={props.templateName}
        formId={props.formId}
        formName={props.formName}
        fieldId={props.fieldId}
      />
    );
  }
  return (
    <FieldWrapper
      onMouseDown={() => mouseDown()}
      x={props.x}
      y={props.y}
      w={props.w}
      h={props.h}
      backgroundColor={props.editable ? props.backgroundColor : getRgba('#ffffff', 0)}
      editable
      id={props.id}
      fieldId={props.fieldId}
    >
      <Label
        text={parsedValue ? `${parsedValue.length} Attachment${parsedValue.length !== 1 ? 's' : ''}` : '0 Attachments'}
        width={props.w}
        align={props.align}
        fontName={props.fontName}
        fontSize={props.fontSize}
        foregroundColor={getHexColorString(props.foregroundColor)}
        foregroundColorOpacity={getOpacityFromRgba(props.foregroundColor)}
      />
      {fileAttachmentModal}
    </FieldWrapper>
  );
}
